import { Controller } from "@hotwired/stimulus"
import { confetti } from "../confetti"

// Animates the live vote board. The board is replaced wholesale by Turbo
// (broadcast or 3s polling), so state is remembered per room across
// replacements and only real transitions are animated:
//   waiting -> voted     : the participant's card flips face down (bounce)
//   * -> revealed        : every card flips over, staggered
//   revealed + consensus : confetti, once per round
const memory = {}

export default class extends Controller {
  static targets = ["tile"]
  static values = { roomId: String, roundId: String, revealed: Boolean, consensus: Boolean, allVoted: Boolean }

  connect() {
    const previous = memory[this.roomIdValue]
    const current = this.snapshot()

    if (previous && previous.roundId === this.roundIdValue) {
      this.animateTransitions(previous, current)
    } else if (previous) {
      // New round (or votes cleared): everything folds back face down.
      this.tileTargets.forEach(tile => tile.classList.add("flip-back"))
    }

    memory[this.roomIdValue] = current
    this.toggleRevealHint()
  }

  snapshot() {
    const states = {}
    this.tileTargets.forEach(tile => { states[tile.dataset.contributorId] = tile.dataset.state })
    return { roundId: this.roundIdValue, states, revealed: this.revealedValue, celebrated: memory[this.roomIdValue]?.celebrated || false }
  }

  animateTransitions(previous, current) {
    const justRevealed = this.revealedValue && !previous.revealed
    let revealIndex = 0

    this.tileTargets.forEach(tile => {
      const before = previous.states[tile.dataset.contributorId]
      const after = tile.dataset.state

      if (after === "revealed" && before !== "revealed") {
        tile.style.setProperty("--delay", `${revealIndex++ * 80}ms`)
        tile.classList.add("flip-reveal")
      } else if (after === "voted" && before !== "voted") {
        tile.classList.add("just-voted")
      } else if (after === "waiting" && before && before !== "waiting") {
        tile.classList.add("flip-back")
      }
    })

    if (justRevealed && this.consensusValue && !current.celebrated) {
      current.celebrated = true
      const total = revealIndex * 80 + 400
      setTimeout(() => confetti(), total)
      this.element.classList.add("consensus")
    }
  }

  // Nudges the moderator's "Reveal Votes" button once everyone has voted.
  toggleRevealHint() {
    const button = document.getElementById("reveal_votes_button")
    if (!button) return
    button.classList.toggle("pulse", this.allVotedValue && !this.revealedValue)
  }
}
